// title
import React from "react";
import { Box, Link, Typography } from "@mui/material";

export default function SectionTitle({title, link}) {
  return (
    <Box
      sx={{
            width: "100%", 
            paddingBottom: 2,
      }}
    >
      <Link
          href={link}
          sx={{
            '&:hover':{
              textDecoration: 'none',
              cursor: 'pointer'
            }
          }}
        >

        <Typography
          variant="h5" 
          sx={{
              color: "primary.main",
              textAlign: "center", 
              // fontWeight: "bold", 
          }}
        >
          {title}
        </Typography>
      </Link>
    </Box>
  );
}
